<template>
  <div>
    <span :key="index" v-for="(tag, index) in tags">
      <v-checkbox
        v-model="tag.status"
        @click="handleCheckboxChange()"
        class="tag-input"
        dense
      >
        <template v-slot:label>
          <span class="application-heading">{{ tag.label }}</span>
        </template>
      </v-checkbox>
    </span>
  </div>
</template>

<script>
import { RISK_CATEGORY_TAGS } from "@/common/constants/riskCategoryTags.js";

const EMITTED_ACTIONS = {
  CHANGE: "change",
};
export default {
  name: "RiskCategoryTag",
  props: {
    selectedTags: {
      type: String,
    },
    reset: {
      type: String,
    },
  },
  data() {
    return {
      tags: this.options(),
    };
  },
  mounted() {
    if (this.selectedTags) {
      this.modifyTagString();
    }
  },
  methods: {
    options() {
      let _options = [];
      RISK_CATEGORY_TAGS.map(function (item) {
        item.status = false;
        _options.push(item);
      });
      return _options;
    },
    handleCheckboxChange() {
      let resultString = this.selectedTagString();
      this.$emit(EMITTED_ACTIONS.CHANGE, {
        selectedTags: resultString,
      });
    },
    selectedTagString() {
      let result = [];
      this.tags.forEach((tag) => {
        if (tag.status) {
          result.push(tag.id);
        }
      });
      return result.join(",");
    },
    modifyTagString(ids = this.selectedTags) {
      let tagIds = ids.split(",");
      this.tags.forEach((tag) => {
        tag.status = tagIds.indexOf(tag.id) > -1;
      });
    },
    handleReset() {
      this.tags.forEach((tag) => {
        tag.status = false;
      });
    },
  },
  watch: {
    reset: {
      handler() {
        this.handleReset();
      },
      deep: true,
    },
    selectedTags: {
      handler(newVal) {
        if (!newVal) {
          this.handleReset();
        } else {
          this.modifyTagString(newVal);
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.tag-input {
  margin: 4px;
}
.tag-input >>> .v-label {
  color: #1c1c1c;
  font-size: 13px !important;
}
.tag-input >>> .v-messages {
  min-height: 0 !important;
}
.tag-input >>> .v-input__slot {
  margin: 0 !important;
}
</style>
